import { CreditCard, ShieldCheck, ArrowRight } from "lucide-react";
import { PageHeader, PrimaryBtn, OutlineBtn } from "@/components/site/shared";
import { useContent } from "@/lib/ContentContext";
import { openGhost } from "@/components/site/GhostAI";

export default function FinancingPage() {
  const { content } = useContent();
  const url = content.financing_url || "https://www.easyquickfund.com";
  return (
    <div>
      <PageHeader overline="Payment Options" title="Financing Options"
        subtitle={content.financing_note || "Financing options may be available through EasyQuickFund."} />
      <section className="section-pad">
        <div className="max-w-3xl mx-auto px-4">
          <div className="bg-white border border-gray-100 rounded-2xl card-shadow p-8">
            <div className="h-14 w-14 rounded-2xl bg-[var(--action)]/10 flex items-center justify-center"><CreditCard className="w-7 h-7 text-[var(--action)]" /></div>
            <h2 className="font-head font-bold text-2xl text-[var(--navy)] uppercase mt-4">Flexible Payment Through EasyQuickFund</h2>
            <p className="text-[var(--text-muted)] mt-3 leading-relaxed">
              {content.financing_note || "Financing options may be available through EasyQuickFund."} EasyQuickFund is an independent third-party financing provider. Approval and terms are determined by the provider — not by Veterans Power Wash & Cleaning Services.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a href={url} target="_blank" rel="noopener noreferrer" className="btn-lift bg-[var(--red)] hover:bg-[var(--red-dark)] text-white font-semibold px-6 py-3 rounded-full inline-flex items-center gap-2">Apply Through EasyQuickFund <ArrowRight className="w-4 h-4" /></a>
              <OutlineBtn onClick={openGhost}>Ask About Financing</OutlineBtn>
              <PrimaryBtn to="/get-a-quote" className="!bg-[var(--navy)] hover:!bg-[var(--navy-800)]">Get a Free Quote</PrimaryBtn>
            </div>
            <div className="mt-6 flex items-start gap-2.5 text-sm bg-[var(--surface)] rounded-xl px-4 py-3">
              <ShieldCheck className="w-5 h-5 text-[var(--action)] shrink-0 mt-0.5" />
              <p className="text-[var(--text-muted)]">{content.financing_disclosure || "Financing is subject to application, approval, and the financing provider's terms."}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
